/* eslint-disable react/jsx-no-bind */
import React, { useState, useContext } from 'react';
import { Flex, Box, Badge, Button, Image, IconButton, Tooltip } from 'pcln-design-system';
import { InformationOutline } from 'pcln-icons';
import styled from 'styled-components';
import { tooltipLogoUrl } from '../../utils/urls';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "PennyToolTip__StyledTooltip",
  componentId: "sc-1ttvr2j-0"
})(["left:", ";width:", ";bottom:", ";z-index:", ";text-align:left;"], props => props.isMobile ? '16px' : '-8px', props => {
  var _a;
  return ((_a = props.styles) === null || _a === void 0 ? void 0 : _a.inputGradientFocus) && props.isMobile ? '80px' : '300px';
}, props => {
  var _a;
  return ((_a = props.styles) === null || _a === void 0 ? void 0 : _a.inputGradientFocus) ? '8px' : null;
}, props => props.zIndex ? props.zIndex : '1');
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "PennyToolTip__StyledFlex",
  componentId: "sc-1ttvr2j-1"
})(["align-items:center;z-index:", ";"], props => props.tooltipZIndex || '10');
/**
 * PennyToolTip - Tooltip for the chatbot
 * @internal
 */
const PennyToolTip = props => {
  const [isDisplayed, setTooltipDisplayState] = useState(false);
  const {
    onClearHistory,
    tooltipZIndex,
    styles
  } = props;
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  const TRAVEL_BOT_LOGO = tooltipLogoUrl((styles === null || styles === void 0 ? void 0 : styles.inputGradientFocus) ? 'penny_portal_logo_v1.0.svg' : 'pcln_bot_penny_logo_v1.1.svg').href;
  const msgPositionProp = props.msgPosition === 'top' ? {
    top: true
  } : {};
  const IconButtonProps = {
    ml: '4px',
    mt: '2px',
    id: 'openTooltipButton',
    'data-testid': 'openTooltipButton',
    title: 'open tooltip',
    icon: React.createElement(InformationOutline, {
      size: 16
    })
  };
  const badgeProps = (styles === null || styles === void 0 ? void 0 : styles.inputGradientFocus) ? {
    mt: 1,
    size: 'captionSmall',
    color: 'text.light',
    bg: 'border.tint'
  } : {
    color: 'primary',
    bg: 'background.light'
  };
  return React.createElement(StyledFlex, {
    tooltipZIndex: tooltipZIndex
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    height: '28',
    width: '68',
    alt: 'Travel Bot Logo',
    mr: 1
  }), React.createElement(Badge, Object.assign({}, badgeProps), "BETA"), onClearHistory && React.createElement(Button, {
    ml: '2',
    size: 'small',
    variation: 'plain',
    onClick: onClearHistory
  }, "Clear"), React.createElement(Box, {
    mr: '0'
  }, React.createElement(IconButton, Object.assign({}, IconButtonProps, {
    onClick: () => setTooltipDisplayState(!isDisplayed)
  })), isDisplayed && React.createElement(StyledTooltip, Object.assign({}, msgPositionProp, {
    zIndex: tooltipZIndex,
    styles: styles,
    bg: 'background.darkest',
    color: 'background.lightest',
    center: isMobile,
    left: !isMobile,
    isMobile: isMobile
  }), "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.", React.createElement("br", null), React.createElement("br", null), "\u00A9 ", new Date().getFullYear(), " Priceline - Patent Pending")));
};
export default PennyToolTip;